import { render, staticRenderFns } from "./rkm.vue?vue&type=template&id=8e4e0d28&"
import script from "./rkm.vue?vue&type=script&lang=js&"
export * from "./rkm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports